import React, { memo } from 'react'

type LiveTVBadgeProps = {
  zoom?: number
}
/**
 *
 * @param zoom: number - size of the live tv badge used to transform the scale of the badge
 * @default zoom: 1
 * @returns LiveTVBadge component
 */
function LiveTVBadge({ zoom = 1 }: LiveTVBadgeProps) {
  return (
    <div className="live-tv-badge" style={{ transform: `scale(${zoom})` }}>
      <div className="live-tv-badge__icon" />
      <p className="live-tv-badge__text">LIVE</p>
    </div>
  )
}

export default memo(LiveTVBadge)
